// Smart door lock. Validates a 4-digit PIN against the logged-in user's password
// locally (the security gate is client-side, same as the Flutter app), then
// publishes OPENDOOR.

import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DeviceShell from '../../components/DeviceShell';
import { useApp } from '../../../../core/state/AppContext';
import { publishCommand } from '../../../../core/utils/deviceController';

export default function DoorScreen({ device }) {
  const { userId, user } = useApp();
  const uno = device.UniqueNumber;
  const [pin, setPin] = useState('');
  const [msg, setMsg] = useState(null);

  const open = () => {
    if (pin === String(user?.Password)) {
      publishCommand(uno, 'OPENDOOR', userId);
      setMsg({ type: 'success', text: 'Door unlock sent.' });
    } else {
      setMsg({ type: 'error', text: 'Incorrect PIN.' });
    }
    setPin('');
  };

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 4 }}>
        <LockOpenIcon sx={{ fontSize: 80, color: 'text.primary' }} />
        <Typography color="text.primary">Enter your PIN to unlock</Typography>
        {msg && <Alert severity={msg.type} sx={{ width: '100%', maxWidth: 320 }}>{msg.text}</Alert>}
        <TextField type="password" value={pin} label="PIN"
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
          inputProps={{ inputMode: 'numeric', maxLength: 4 }}
          sx={{ width: '100%', maxWidth: 320 }} />
        <Button variant="contained" onClick={open} sx={{ width: '100%', maxWidth: 320, py: 1.5 }}>
          Unlock
        </Button>
      </Box>
    </DeviceShell>
  );
}
